import React, { useState, useRef, useEffect } from "react";
import {
  Box,
  Button,
  Popper,
  Paper,
  ClickAwayListener,
  MenuItem,
  TextField,
  Autocomplete,
  InputAdornment,
  Stack,
  Chip,
  Menu,IconButton, ListItemText, ListItemSecondaryAction
} from "@mui/material";
import { debounce } from "lodash";

import LocationOnIcon from "@mui/icons-material/LocationOn";
import HomeIcon from "@mui/icons-material/Home";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import CloseIcon from '@mui/icons-material/Close';
import httpCommon from '../../http-common';



const AdvancedSearch = ({ locations = [], propertyTypes = [], budgets = [], onSearch,defaultValues = {}  }) => {
  const [formData, setFormData] = useState({
  
        location: defaultValues.location || [],
        projectTitle: defaultValues.projectTitle || [],
        propertyType: defaultValues.propertyType || [],
        minBudget: defaultValues.minBudget || "",
        maxBudget: defaultValues.maxBudget || "",
  });

  const [budgetOpen, setBudgetOpen] = useState(false); // ✅ open by default
  const budgetRef = useRef(null);
  const [showAllTags, setShowAllTags] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [inputValue, setInputValue] = useState("");
  const [options, setOptions] = useState([]);

  // Update formData when defaultValues change (when navigating from home page)
    useEffect(() => {
        if (defaultValues && Object.keys(defaultValues).length > 0) {
            setFormData({
                location: defaultValues.location || [],
                projectTitle: defaultValues.projectTitle || [],
                propertyType: defaultValues.propertyType || [],
                minBudget: defaultValues.minBudget || "",
                maxBudget: defaultValues.maxBudget || "",
            });
        }
    }, [defaultValues]);


  // Debounced API call
const fetchLocations = useRef(
  debounce(async (value) => {
    try {
      const res = await httpCommon.get(`/list`);
      const dataArray = res.data.data;
//console.log("dataArray____res___",dataArray);
      const searchValue = value.toLowerCase().trim();
      const keywords = searchValue.split(/\s+/);
      const filteredResults = dataArray
        .filter((item) => {
          // Combine all searchable fields into one string
         
const combined = `
            ${item.ltg_projectName || ''}
            ${item.ltg_regions || ''}
            ${item.ltg_title || ''}
          `.toLowerCase();
          // Check if **every keyword** exists in the combined string (AND logic)
          return (
        keywords.every(keyword => combined.includes(keyword)) &&
        item.ltg_det_sold_type !== "1"
      );
        })
        .sort(
          (a, b) =>
            new Date(b.ltg_det_create_date) - new Date(a.ltg_det_create_date)
        );
    //    console.log("filteredResults____",filteredResults);
      setOptions(filteredResults);
    //  setOptions(filteredResults.map((item) => item.ltg_projectName));
    } catch (err) {
      console.error("Failed to fetch location options", err);
    }
  }, 400)
).current;

useEffect(() => {
  if (inputValue.trim().length >= 1) {
    fetchLocations(inputValue);
  } else {
    setOptions([]);
  }
}, [inputValue]);


 const handleBudgetSelect = (type, value) => {
  if (type === "minBudget") {
    setFormData((prev) => ({
      ...prev,
      minBudget: value,
      maxBudget: "", // reset maxBudget on minBudget change
    }));
  } else {
    setFormData((prev) => ({
      ...prev,
      maxBudget: value,
    }));
    setBudgetOpen(false); // auto-close after max selection
  }
};

const formatBudget = (value) => {
  if (value >= 100) return `${value / 100} Cr`;
  return `${value} LAC`;
};

const displayBudgetLabel = () => {
  const { minBudget, maxBudget } = formData;
  if (minBudget && maxBudget)
    return `${formatBudget(minBudget)} - ${formatBudget(maxBudget)}`;
  if (minBudget) return `Min ${formatBudget(minBudget)}`;
  if (maxBudget) return `Max ${formatBudget(maxBudget)}`;
  return "Budget";
};
console.log("formData___",formData);

  return (
    <Stack
      direction={{ xs: 'column', sm: 'row' }}
      spacing={2}
      sx={{
        borderRadius: "30px",
        bgcolor: "#fff",
        boxShadow: 2,
        p: 2,
        flexWrap: { xs: "wrap", sm: "nowrap" },
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%",
      }}
    >
    
<Autocomplete
  multiple
  freeSolo
  options={(() => {
    // Remove duplicates based on ltg_projectName + ltg_regions
    const uniqueOptions = [];
    const seen = new Set();
    options.forEach(option => {
      const key = `${option.ltg_projectName || ''}-${option.ltg_regions || ''}`;
      if (!seen.has(key)) {
        seen.add(key);
        uniqueOptions.push(option);
      }
    });
    return uniqueOptions;
  })()}
  value={formData.projectTitle.map(title =>
    options.find(opt => opt.ltg_projectName === title) || title
  )}
  getOptionLabel={(option) => {
    if (typeof option === "string") return option;

    const projectName = option.ltg_projectName || '';
    const location = option.ltg_det_location || '';
    const region = option.ltg_regions || '';

    const truncatedLocation = location.length > 10 ? location.substring(0, 10) + '...' : location;

    return `${projectName}${truncatedLocation ? ' - ' + truncatedLocation : ''}${region ? ' - ' + region : ''}`;
  }}
  filterOptions={(filteredOptions, { inputValue }) => {
    if (!inputValue) return filteredOptions;
    const searchTerm = inputValue.toLowerCase();

    return filteredOptions.filter(option => {
      const projectName = (option.ltg_projectName || '').toLowerCase();
      const location = (option.ltg_det_location || '').toLowerCase();
      const region = (option.ltg_regions || '').toLowerCase();
      const title = (option.ltg_title || '').toLowerCase();

      return projectName.includes(searchTerm) ||
             location.includes(searchTerm) ||
             region.includes(searchTerm) ||
             title.includes(searchTerm);
    });
  }}
  onChange={(e, newValue, reason) => {
    if (reason === "createOption") {
      // User typed/pasted free text
      const projectNames = newValue.map((item) =>
        typeof item === "string" ? item : (item.ltg_projectName || item.ltg_title || "")
      );
      setFormData((prev) => ({
        ...prev,
        projectTitle: projectNames,
      }));
    } else if (reason === "selectOption" || reason === "removeOption" || reason === "clear") {
      // User selected from dropdown or removed/cleared
      const projectNames = newValue.map((item) =>
        typeof item === "string" ? item : (item.ltg_projectName || "")
      );
      setFormData((prev) => ({
        ...prev,
        projectTitle: projectNames,
      }));
    }
  }}
  onInputChange={(event, newInputValue, reason) => {
    if (reason !== "reset") setInputValue(newInputValue);
  }}
  filterSelectedOptions
  renderTags={(value, getTagProps) => {
    if (!value.length) return null;

    const first = value[0];
    const rest = value.slice(1);

    const handleMoreClick = (event) => setAnchorEl(event.currentTarget);
    const handleClearAll = () => {
      setFormData((prev) => ({
        ...prev,
        projectTitle: [],
      }));
      setAnchorEl(null);
      setShowAllTags(false);
    };

    return [
      <Chip
        label={typeof first === 'string' ? first : first.ltg_projectName || ''}
        {...getTagProps({ index: 0 })}
        key={typeof first === 'string' ? first : first.ltg_projectName}
        sx={{ mr: 1 }}
      />,
      rest.length > 0 && (
        <Chip
          label={`+${rest.length}`}
          onClick={handleMoreClick}
          key="more-chip"
          sx={{ backgroundColor: "#f0f0f0", cursor: "pointer" }}
        />
      ),
      <Menu
        key="dropdown-menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        PaperProps={{ style: { maxHeight: 300, minWidth: 220 } }}
      >
        {rest.map((option, idx) => (
          <MenuItem key={idx} divider>
            <ListItemText primary={typeof option === 'string' ? option : option.ltg_projectName || option.ltg_title || ''} />
          </MenuItem>
        ))}
        {rest.length > 0 && (
          <MenuItem
            onClick={handleClearAll}
            sx={{
              color: "red",
              fontWeight: "bold",
              borderTop: "1px solid #ddd",
            }}
          >
            Clear All
          </MenuItem>
        )}
      </Menu>,
    ];
  }}
  renderOption={(props, option) => {
    const projectName = option.ltg_projectName || '';
    const location = option.ltg_det_location || '';
    const region = option.ltg_regions || '';

    const truncatedLocation = location.length > 10 ? location.substring(0, 10) + '...' : location;

    const displayText = [projectName, truncatedLocation, region]
      .filter(Boolean)
      .join(' , ');

    return (
      <li {...props} key={`${option.ltg_projectName}-${option.ltg_regions}` || Math.random()}>
        <div style={{
          display: "flex",
          alignItems: "flex-start",
          width: "100%",
          padding: "8px 0"
        }}>
          <span style={{
            fontSize: "14px",
            fontWeight: "500",
            color: "#333",
            whiteSpace: "normal",
            wordWrap: "break-word",
            lineHeight: "1.4",
            width: "100%"
          }}>
            📍 {displayText}
          </span>
        </div>
      </li>
    );
  }}
  renderInput={(params) => (
    <TextField
      {...params}
      variant="standard"
      placeholder="Enter City, Locality, Project"
      InputProps={{
        ...params.InputProps,
        disableUnderline: true,
        startAdornment: (
          <>
            <InputAdornment position="start">
              <LocationOnIcon color="error" />
            </InputAdornment>
            {params.InputProps.startAdornment}
          </>
        ),
      }}
      sx={{ minWidth: 300 }}
      onKeyDown={(e) => {
        if (
          e.key === "Enter" &&
          formData.projectTitle.length > 0 &&
          inputValue.trim() !== ""
        ) {
          e.preventDefault();
          onSearch(formData);
        }
      }}
    />
  )}
  sx={{ maxWidth: 400 }}
/>


      {/* Property Type Dropdown */}
    <TextField
    select
    variant="standard"
    SelectProps={{
      multiple: true,
      displayEmpty: true,
      renderValue: (selected) => {
        if (!selected.length) return <span style={{ color: '#aaa' }}>Property Type</span>;
        const first = selected[0];
        const rest = selected.length - 1;
        return rest > 0 ? `${first} +${rest}` : first;
      },
    }}
  InputProps={{
    disableUnderline: true,
    startAdornment: (
      <InputAdornment position="start">
        <HomeIcon color="error" />
      </InputAdornment>
    ),
  }}
  value={formData.propertyType}
  onClick={(e) => e.stopPropagation()} // prevent double open
  sx={{ minWidth: 150 }}
>
  <MenuItem disabled value="">
    Property Type
  </MenuItem>

  {propertyTypes.map((type, index) => (
    <MenuItem
      key={index}
      value={type}
      onClick={(e) => {
        e.stopPropagation(); // prevent double toggle
        setFormData((prev) => {
          const exists = prev.propertyType.includes(type);
          const newTypes = exists
            ? prev.propertyType.filter((t) => t !== type)
            : [...prev.propertyType, type];
          return {
            ...prev,
            propertyType: newTypes,
          };
        });
      }}
    >
      <input
        type="checkbox"
        checked={formData.propertyType.includes(type)}
        readOnly
        style={{ marginRight: 8 }}
      />
      {type}
    </MenuItem>
  ))}
</TextField>




      {/* Budget Dropdown Trigger */}
      <Box ref={budgetRef}>
        <Button
          variant="text"
          onClick={() => setBudgetOpen((prev) => !prev)}
          startIcon={<CurrencyRupeeIcon color="error" />}
          sx={{
            color: "#333",
            textTransform: "none",
            borderRadius: "20px",
          }}
        >
          {displayBudgetLabel()}
        </Button>

        {/* Budget Dropdown Content */}
   <Popper
  open={budgetOpen}
  anchorEl={budgetRef.current}
  placement="bottom-start"
  disablePortal
   modifiers={[
    {
      name: "preventOverflow",
      options: {
        altBoundary: true,
        tether: false,
        rootBoundary: "viewport",
        padding: 8,
      },
    },
  ]}
  style={{ zIndex: 1300 }} 
>
  <ClickAwayListener onClickAway={() => setBudgetOpen(false)}>
    <Paper sx={{ p: 2, borderRadius: 2, minWidth: 300, height:200, overflow:"auto" }}>
      <Stack direction="row" spacing={4} className="hhhh">

        {/* Min Price */}
      <Box sx={{ flex: 1 }}>
      <Box fontWeight="bold" mb={1}>Min Price</Box>
        <Stack spacing={1}>
          {budgets.map((price, i) => {
            const label =
              price > 75
                ? `₹${(price / 100).toFixed(2)} Cr`
                : `₹${price} LAC`;

            return (
              <Button
                key={`min-${i}`}
                onClick={() => handleBudgetSelect("minBudget", price)}
                size="small"
                fullWidth
                sx={{
                  justifyContent: "flex-start",
                  textTransform: "none",
                  color: "blue",
                  bgcolor:
                    formData.minBudget === price ? "#f0f0f0" : "transparent",
                }}
              >
                {label}
              </Button>
            );
          })}
        </Stack>
      </Box>


        {/* Max Price */}
        {formData.minBudget && (
          <Box sx={{ flex: 1 }}>
            <Box fontWeight="bold" mb={1}>Max Price</Box>
            <Stack spacing={1}>
              {budgets
                .filter((price) => price > parseInt(formData.minBudget))
                .map((price, i) => (
                  <Button
                    key={`max-${i}`}
                    onClick={() => handleBudgetSelect("maxBudget", price)}
                    size="small"
                    fullWidth
                    sx={{
                      justifyContent: "flex-start",
                      textTransform: "none",
                      color: "blue",
                      bgcolor:
                        formData.maxBudget === price ? "#f0f0f0" : "transparent",
                    }}
                  >
                    ₹{price >= 100 ? `${price / 100} Cr` : `${price} LAC`}
                  </Button>
                ))}
            </Stack>
          </Box>
        )}
      </Stack>
    </Paper>
  </ClickAwayListener>
</Popper>


      </Box>

      {/* Search Button */}
      <Button
        variant="contained"
        sx={{
          flexShrink: 0,
          whiteSpace: "nowrap", 
          
          mt: { xs: 2, sm: 0 },
          borderRadius: "30px",
          px: 3,
          bgcolor: "#2196F3",
          color: "#fff",
          "&:hover": {
            bgcolor: "#1976D2",
          },
        }}
        onClick={() => onSearch(formData)}
      >
        🔍 SEARCH
      </Button>
    </Stack>
  );
};

export default AdvancedSearch;
